// extracted by mini-css-extract-plugin
export default {"wrapper":"invoice-downloaded-modal_wrapper__OnS9V","button":"invoice-downloaded-modal_button__rRuQa","opacity-transition":"invoice-downloaded-modal_opacity-transition__-McBo"};